import './LegalPage.css';

export default function PrivacyPage() {
  const handleBack = () => {
    if (window.history.length > 1) window.history.back();
    else window.close();
  };

  return (
    <div className="legal-page">
      <header className="legal-header">
        <button className="legal-back-btn" onClick={handleBack}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M15 18l-6-6 6-6" />
          </svg>
        </button>
        <span className="legal-title">개인정보처리방침</span>
      </header>

      <div className="legal-body">
        <p className="legal-date">시행일: 2026년 3월 2일</p>

        <h2>1. 개인정보의 처리 목적</h2>
        <p>인생로그(이하 "서비스")는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.</p>
        <ul>
          <li>회원 가입 및 관리: 회원 가입 의사 확인, 회원 식별, 서비스 제공</li>
          <li>서비스 제공: 인생 기록 저장, 타임라인 관리, 기록 공유 기능</li>
          <li>서비스 개선: 서비스 이용 통계 분석 및 품질 향상</li>
        </ul>

        <h2>2. 수집하는 개인정보 항목</h2>
        <h3>필수 항목</h3>
        <ul>
          <li>이메일 주소 (회원가입 시)</li>
          <li>비밀번호 (이메일 가입 시, 암호화 저장)</li>
        </ul>
        <h3>소셜 로그인 시</h3>
        <ul>
          <li>카카오 로그인: 카카오 계정 이메일, 닉네임</li>
          <li>구글 로그인: 구글 계정 이메일, 이름</li>
        </ul>
        <h3>서비스 이용 시 생성되는 정보</h3>
        <ul>
          <li>기록 데이터: 제목, 날짜, 메모, 카테고리</li>
          <li>사진: 사용자가 직접 업로드한 이미지</li>
          <li>위치 정보: 사용자가 직접 입력하거나 선택한 장소명 및 좌표 (선택)</li>
        </ul>

        <h2>3. 개인정보의 처리 및 보유 기간</h2>
        <p>이용자의 개인정보는 서비스 이용 기간 동안 보유하며, 회원 탈퇴 시 지체 없이 파기합니다.</p>
        <ul>
          <li>회원 탈퇴 시: 모든 개인정보 및 기록 데이터 즉시 삭제</li>
          <li>관련 법령에 따른 보존이 필요한 경우 해당 법령에서 정한 기간 동안 보관</li>
        </ul>

        <h2>4. 개인정보의 제3자 제공</h2>
        <p>서비스는 이용자의 개인정보를 제3자에게 제공하지 않습니다. 다만, 다음의 경우에는 예외로 합니다.</p>
        <ul>
          <li>이용자가 사전에 동의한 경우</li>
          <li>법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우</li>
        </ul>

        <h2>5. 개인정보의 파기</h2>
        <p>서비스는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체 없이 해당 개인정보를 파기합니다.</p>
        <ul>
          <li>전자적 파일 형태의 정보는 복구할 수 없는 방법으로 삭제</li>
          <li>종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각하여 파기</li>
        </ul>

        <h2>6. 개인정보의 안전성 확보 조치</h2>
        <p>서비스는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.</p>
        <ul>
          <li>비밀번호 암호화 저장</li>
          <li>SSL/TLS를 통한 데이터 전송 암호화</li>
          <li>접근 권한 관리 및 제한</li>
          <li>Supabase RLS(Row Level Security)를 통한 데이터 접근 제어</li>
        </ul>

        <h2>7. 이용자의 권리 및 행사 방법</h2>
        <p>이용자는 언제든지 다음의 권리를 행사할 수 있습니다.</p>
        <ul>
          <li>개인정보 열람 요구</li>
          <li>개인정보 수정 요구</li>
          <li>개인정보 삭제 요구</li>
          <li>개인정보 처리 정지 요구</li>
          <li>회원 탈퇴 (설정 &gt; 회원 탈퇴)</li>
        </ul>

        <h2>8. 개인정보 보호책임자</h2>
        <ul>
          <li>이메일: onetiger87@gmail.com</li>
        </ul>
        <p>개인정보 처리에 관한 불만이나 피해구제 등에 관한 사항은 위 이메일로 문의해 주시기 바랍니다.</p>

        <h2>9. 개인정보처리방침 변경</h2>
        <p>이 개인정보처리방침은 2026년 3월 2일부터 적용됩니다. 변경사항이 있을 경우 서비스 내 공지를 통해 안내드리겠습니다.</p>
      </div>
    </div>
  );
}
